import type { Types                           } from '../types';


export default (
  // schedule: CoreTypes.schedule
): Types.subject | null => {
  return null;
};
